import { Pause, Play } from "lucide-react";
import { t, useLanguage } from "@/i18n/LanguageContext";

const MACHINES_PER_GROUP = 12;
const MACHINES = [
  { kind: "excavator", sprite: "/brochure/excavator-mini.webp" },
  { kind: "bobcat", sprite: "/brochure/bobcat-mini.webp" },
];

export const ExcavatorMarquee = ({ prefix, paused, reducedMotion, motionState, onToggle }) => {
  useLanguage();
  const label = paused ? "Riprendi le animazioni" : "Metti in pausa le animazioni";
  return <div data-testid={`${prefix}-excavator-strip`} className="gfc-excavator-strip">
    <div data-testid={`${prefix}-excavator-viewport`} className="gfc-excavator-viewport" aria-hidden="true">
      <div data-testid={`${prefix}-excavator-track`} data-motion={motionState} className="gfc-excavator-track">
        {[0, 1].map((group) => <div key={group} data-testid={`${prefix}-excavator-group-${group}`} className="gfc-excavator-group">
          {Array.from({ length: MACHINES_PER_GROUP }, (_, index) => {
            const machine = MACHINES[index % MACHINES.length];
            return <span key={index} className="gfc-excavator-slot">
              <img data-testid={`${prefix}-${machine.kind}-${group}-${index}`} data-machine={machine.kind} src={machine.sprite} alt="" width="320" height="217" decoding="async" className="gfc-excavator-image" />
            </span>;
          })}
        </div>)}
      </div>
    </div>
    {!reducedMotion && <button type="button" data-testid={`${prefix}-motion-toggle`} data-brochure-motion-control="true" title={t(label)} aria-label={t(label)} onClick={onToggle} className="gfc-excavator-toggle">
      {paused ? <Play size={17} aria-hidden="true" /> : <Pause size={17} aria-hidden="true" />}
    </button>}
  </div>;
};